import type { ReactNode } from 'react';

import { NotFoundVisual } from './not-found-visual';

/**
 * Figma „Section · 404“ (186:15196) and its card (186:15197): the grey card – radius 16, 346 px
 * visual (`visual`, the „404“ rainbow by default), 64 px, the text column with `children` – that the
 * 404 page and the error page share.
 */
export function NotFoundCard({
  visual = <NotFoundVisual />,
  children,
}: {
  visual?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="custom-section py-6 md:py-10">
      <div className="custom-container">
        <div className="flex flex-col items-center gap-8 rounded-2xl bg-[#F5F6F3] p-6 md:p-10 lg:flex-row lg:gap-16">
          {visual}
          <div className="flex w-full min-w-0 flex-col gap-6 lg:flex-1">{children}</div>
        </div>
      </div>
    </section>
  );
}
